import { useMutation } from '@tanstack/react-query'

import type { UploadBlob } from '../../../../../components/ImageUpload/GalleryImageUploader.types'
import type { OfferImagesFilter } from '../../types'
import { mapUploadedFilesToVariantImages } from './mapUploadedFilesToVariantImages/mapUploadedFilesToProductVariantImages'
import { useUploadImageMutation } from './useUploadImageMutation'

export const useUploadImages = ({ filters }: { filters: OfferImagesFilter[] }) => {
  const { uploadImageMutation } = useUploadImageMutation()

  const mapFileToUploadPromise = (file: Blob) => {
    const formData = new FormData()

    formData.append('file', file)

    return uploadImageMutation.mutateAsync([formData])
  }

  const uploadBlobs = async (images: UploadBlob[]) => {
    const promises = images.map(async (image) => {
      const result = await mapFileToUploadPromise(image.blob)

      return {
        result,
        uploadToAllVariants: image.uploadToAllVariants,
      }
    })

    const results = await Promise.all(promises)

    const mappedImages = mapUploadedFilesToVariantImages({ results, filters })

    return mappedImages
  }

  return { uploadBlobs: useMutation(uploadBlobs) }
}
